import { Component, OnInit, Inject } from '@angular/core';
import { Recipient } from '../../models/interpretation.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CryptoService } from '../../../../../app/services/crypto.service';

@Component({
  selector: 'app-add-recipient',
  templateUrl: './add-recipient.component.html',
  styleUrls: ['./add-recipient.component.scss']
})
export class AddRecipientComponent implements OnInit {

  constructor(private _dialogRef: MatDialogRef<AddRecipientComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,private _crypto: CryptoService) { }

  ngOnInit() {
  }


  customerName: string;
  email:string; 

  onAddClick() {
    let newRecipient = new Recipient();
    newRecipient.Name = this._crypto.encrypt(this.customerName);
    newRecipient.Email = this._crypto.encrypt(this.email);
    newRecipient.DecryptedEmail= this.email;
    newRecipient.DecryptedName= this.customerName;
    this._dialogRef.close(newRecipient);
  }

  onCancelClick() {
    this._dialogRef.close();
  }
}
